module.exports = __webpack_public_path__ + "static/media/age_gender_model.c34648b1.bin";